"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNewsArticles = void 0;
exports.defaultNewsArticles = {
    items: [{
            id: 690,
            content: '6 December 2017 - In a bustling metropolis like Hong Kong, finding an apartment in a laid-back neighbourhood without emptying your bank account sounds like mission impossible. But let’s forget The Peak for a second: here are five affordable chilled-out districts that could ease your real estate qualms:   \r\n\r\n\t   \r\n\r\n\tWestern District\r\n\r\n\t\r\n\r\n\tEvery',
            title: '5 Chilled-Out Residential Areas that Won’t Break the Bank',
            url: 'https://dev.okay.com/property-questions/5-chilled-out-residential-areas-that-wont-break-the-bank/690',
            altText: 'Chilled Out Hong Kong Districts',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/690_636481798524018903.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Dec  6 2017',
        }, {
            id: 670,
            content: '香港寸土尺金，居住空間有限，相信用盡屋企每吋空間是不少人的目標。其實只要動動腦筋，在家居設計和收納方面著手，便能更靈活地運用室內空間，打造既實用又有型的安樂窩。OKAY.com為您提供5個家居慳位設計貼士，讓您掌握節省空間的要訣，活用全屋每個角落。\r\n\r\n\t \r\n\r\n\t1. 以櫃代牆作為間隔\r\n\r\n\t \r\n\r\n\t現代家居慳位設計的一大妙法就是以櫃代牆，一來可省去牆身所佔的面積，二來大大增加收納空間，同時亦可增加室內的空間感，可謂一舉多得。不少蝸居都採用衣櫃來分隔客廳和睡房，一面儲物，另一面可懸掛電視，令單位整體空間感更大。除了以櫃代牆外，趟櫃代門亦是另一好選擇，既可增添額外儲物空間，亦可透過個人擺設為家居增添獨特設計。\r\n\r\n\t \r\n\r\n\t \r\n\r\n\t2. 善用入牆及掛牆櫃\r\n\r\n\t \r\n\r',
            title: '5個家居慳位設計貼士',
            url: 'https://dev.okay.com/property-guides/5-tips-for-optimizing-space-in-hk-homes/670',
            altText: '5個家居慳位設計貼士 - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/670_636453247363555198.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Nov  7 2017',
        }, {
            id: 453,
            content: 'The Best Ways to Transition your Child into a New Home \r\n\r\n\t \r\n\r\n\tMoving houses and settling into a new home signifies a new start, but the process can be stressful for the whole family, especially for the children. In the midst of packing and unpacking, how do you best help your kids cope with this change in their lives? Here are a few key things ',
            title: 'How to Help Children Adjust to a New Home',
            url: 'https://dev.okay.com/property-guides/how-to-help-children-adjust-to-a-new-home/453',
            altText: 'How to Help Children Adjust to a New Home - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/453_636308074988861417.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'May 19 2017',
        }, {
            id: 400,
            content: 'Moving to Hong Kong is far from cost-effective. Add in an entire family unit with young children in tow and the move becomes all the more complicated in terms of logistics. Be it education, living space and the process of acculturation, this guide aims to provide a few pointers which will inform your move.   \r\n\r\n\t \r\n\r\n\tEducation\r\n\r\n\t \r\n\r\n\t\r\n\r\n\tPrio',
            title: 'Moving to Hong Kong with Kids',
            url: 'https://dev.okay.com/property-guides/moving-to-hong-kong-with-kids/400',
            altText: 'Moving to Hong Kong with Kids - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/400_636175036636661127.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Dec 16 2016',
        }, {
            id: 397,
            content: 'Family friendly neighborhoods abound in Hong Kong. Factoring in price, location, the subsequent sense of convenience, proximity to schools and the range of scenery, your personal preference is the overriding determinant. Our brief overview of family friendly neighborhoods both on and off Hong Kong Island aims to inform the general direction of your',
            title: 'Family Friendly Expat Neighborhoods in Hong Kong',
            url: 'https://dev.okay.com/property-guides/family-friendly-expat-neighborhoods-in-hong-kong/397',
            altText: 'happy family in Hong Kong',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/397_636173935926839032.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Dec 13 2016',
        }, {
            id: 387,
            content: '6 October 2016 - Hong Kong is not only known for its sky high property prices, extravagant skyscrapers and shopping malls, but also swathes of country parks, mountains and wetlands which account for a surprising 73% of Hong Kong’s land area – who knew? For those looking to take a pause from the hustle-and-bustle of city life, hiking trails abound a',
            title: 'Top 5 Weekend Hiking Trails in Hong Kong',
            url: 'https://dev.okay.com/property-questions/top-5-weekend-hiking-trails-in-hong-kong/387',
            altText: "Dragon's Back, Hong Kong",
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/387_636113699683608897.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Oct  6 2016',
        }, {
            id: 385,
            content: 'HK Trams, or “Ding Dings” are a unique form of transport and moving monuments that have been traversing Hong Kong Island for over 100 years. It is namely the best way to explore the city for both tourists and locals. Hop onto one of them and find your way around with the most affordable and convenient transport!  \r\n\r\n\t \r\n\r\n\tSpanning across the nort',
            title: 'Hong Kong Trams: Riding the Ding Ding',
            url: 'https://dev.okay.com/property-guides/hong-kong-trams-riding-the-ding-ding--/385',
            altText: 'Hong Kong Trams: Riding the Ding Ding - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/385_636093735187638992.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Sep 19 2016',
        }, {
            id: 384,
            content: '14 September 2016 - With limited living space in a concrete jungle like Hong Kong, homeowners are eager to utilize every square foot of their properties as efficiently as possible. One common method is to demolish the wall of the existing kitchen to turn it into an open one. An open kitchen is certainly a popular choice today, but before you knock ',
            title: 'Open Kitchens in Hong Kong: A Good or Bad Idea?',
            url: 'https://dev.okay.com/property-questions/open-kitchens-in-hong-kong-a-good-or-bad-idea/384',
            altText: 'Open Kitchens in Hong Kong: A Good or Bad Idea? - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/384_636093674918658862.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Sep 14 2016',
        }, {
            id: 383,
            content: 'So, you’ve signed a tenancy agreement or finally made the leap onto HK’s lucrative property ladder. Moving dates are sorted and you are looking forward to creating new memories in your new house. But first… the daunting task of moving home must be attended to. \r\n\r\n\t \r\n\r\n\tMoving is often said to be the third most stressful event in one’s life, behin',
            title: '8 Things to Do To Make Moving Easier within HK',
            url: 'https://dev.okay.com/property-guides/8-things-to-do-to-make-moving-easier-within-hk/383',
            altText: 'Moving in Hong Kong',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/383_636090190488878384.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Sep  9 2016',
        }, {
            id: 382,
            content: '6 September 2016 - A region that can generally be described as the patch of land situated halfway up the Peak, Mid-Levels is primarily a prime residential location for those who place high value upon living in close proximity to the work place. With the Mid-Levels Escalator providing an 800 meter stretch of open “effortless” transportation between ',
            title: 'Mid-Levels: Beyond the Commute Connection',
            url: 'https://dev.okay.com/property-questions/mid-levels-beyond-the-commute-connection/382',
            altText: 'Mid-Levels, Hong Kong',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/382_636087800234022542.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: 0,
                },
            ],
            dateAdded: 'Sep  6 2016',
        },
    ],
    pager: {
        totalItems: 58,
        currentPage: 1,
        pageSize: 10,
        totalPages: 6,
        startPage: 1,
        endPage: 6,
        hasPreviousPage: false,
        hasNextPage: true,
    },
    translate: {
        by: 'By',
        first: 'First',
        last: 'Last',
        next: 'Next',
        previous: 'Previous',
    },
};
